<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
import VueCookies from "vue-cookies";
export default {
    name: 'business',
    data: function(){
        return {

        }
    },
    mounted(){
        console.log(this.$route)
        //if(!localStorage.getItem("token")){
        if(!VueCookies.get("token")){
            this.$router.push('/business/login')
        }else{
            if(this.$route['path'] === '/business'){
                this.$store
                    .dispatch("authorize_checking")
                    .then(msg => {
                        if (msg.status === "Access Granted") {
                            this.$router.push("/business/allinbox");
                        } else if (msg.code === "LN001") {
                            this.$router.push('/business/login')
                        } else {
                            this.$router.push('/business/login')
                        }
                    })
            }
        }
    }
}
</script>